import React from "react";

import styles from "./ListCard.module.scss";
import { OrderProps } from "../../types/order";
import moment from "moment";
import { Link } from "react-router-dom";
import { route } from "../../static/route";
import OrderCloseForm from "./OrderCloseForm";

type Props = {
  order: OrderProps;
  index?: number | undefined;
};

const ListCard = ({ order, index }: Props) => {
  return (
    <div className={styles.ListCard}>
      <h5 className="text-primary-1 text-lg font-semibold">
        કામ નું આઇડી : {order.id}
      </h5>

      <div className="flex flex-col gap-3 mt-5">
        <p className="text-primary-1 text-sm font-semibold">
          પાર્ટી :{" "}
          {order.party.firm_name +
            (order.party.name ? " - " + order.party.name : "") +
            (order.party.phone ? " (" + order.party.phone + ")" : "")}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          આઈટમ : {order.item.name}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          પ્રોસેસ : {order.process.name}
        </p>
        <p className="text-primary-1 text-sm font-semibold">
          યુનિટ : {order.unit.name}
        </p>
        {/* <p className="text-primary-1 text-sm font-semibold">
          રેટ/ભાવ : {order.rate}
        </p> */}
        <p className="text-primary-1 text-sm font-semibold">
          {order.unit_id === 3 ? "જોડી" : order.unit_id === 2 ? "નંગ" : "વજન"} :{" "}
          {order.qty}
        </p>
        {order.unit_id > 1 && (
          <p className="text-primary-1 text-sm font-semibold">
            વજન : {order.weight}
          </p>
        )}
        {order.status === 1 && (
          <>
            <p className="text-primary-1 text-sm font-semibold">
              ડિલિવર કરેલ{" "}
              {order.unit_id === 3
                ? "જોડી"
                : order.unit_id === 2
                ? "નંગ"
                : "વજન"}{" "}
              : {order.delivered_qty}
            </p>

            {order.unit_id > 1 && (
              <p className="text-primary-1 text-sm font-semibold">
                ડિલિવર કરેલ વજન : {order.delivered_weight}
              </p>
            )}

            <p className="text-primary-1 text-sm font-semibold">
              ડિલિવર કરેલ તારીખ :{" "}
              {moment(order.delivered_date, "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY hh:mm A"
              )}
            </p>

            {/* <p className="text-primary-1 text-sm font-semibold">
              અમાઉન્ટ : {order.amount}
            </p> */}
          </>
        )}
        <p className="text-primary-1 text-sm font-semibold">
          ડિઝાઇન : {order.design}
        </p>
      </div>

      {index !== undefined && index >= 0 ? (
        <OrderCloseForm index={index} unit_id={order.unit_id} />
      ) : (
        <Link to={route.orderDetails + `/${order.id}`}>
          <button
            className="mx-auto flex gap-3 mt-6 shadow disabled:opacity-50 rounded-3xl text-1xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
            type="button"
          >
            કામ ની વિગતો જુઓ
          </button>
        </Link>
      )}
    </div>
  );
};
export default ListCard;
